<template>
    <el-dialog title="导入发放" :visible.sync="dialogVisible" width="768px" :before-close="handleClose">
        <div class="main">
            <div class="file">
                <span>上传文件：</span>
                <el-upload action="#" accept=".pdf, .doc, .docx, .xls, .xlsx" :auto-upload="false" :file-list="fileList" :on-change="(file, fileList) => handleChange(file, fileList)">
                    <el-input size="small" v-model="url" type="primary" style="width: 400px" placeholder="请选择导入文件">点击上传</el-input>
                </el-upload>
            <el-link style="margin-left:22px" type="primary" @click="getTMUrl">模板下载</el-link>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="onSubmit">提交发放</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import config from "@/assets/config.json";
export default {
    data() {
        return {
            expireTimeOption: {
                disabledDate(date) {
                    //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                },
            },
            dialogVisible: false,
            url: "",
            fileList: [],
            id: "",
            formData: null,
        };
    },
    computed: {
        ...mapGetters({
            getToken: "getToken",
        }),
    },
    methods: {
        ...mapActions({
            importCard: "detect/importCard",
        }),
        // 下载模板链接
        getTMUrl() {
            window.open(`${config.brandHttps.api}/merchant/agency/downloadtemplate?token=${this.getToken}&port=coupons`);
        },
        handleChange(file, fileList) {
            this.url = file.name;
            var formdata = new FormData();
            formdata.append("coupon", file.raw);
            formdata.append("token", this.getToken);
            formdata.append("id", this.id);
            this.FormData = formdata;
            this.fileList = fileList;
            // this.uploadFile(formdata).then((res) => {
            //     if (res.code == 1) {
            //         // console.log(res);
            //         this.$message.success("上传成功！");
            //         this.url = res.data.formdata_details[0].urls;
            //     } else {
            //         this.$message({
            //             type: "warning",
            //             message: res.msg,
            //         });
            //     }
            // });
        },
        onSubmit() {
            this.importCard(this.FormData).then(({ data }) => {
                console.log(data);
                if (data.code == 1) {
                    this.$message.success("导入成功！");
                    this.handleClose()
                    this.$emit("init")
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        handleClose() {
            this.dialogVisible = false;
            this.url = "";
            this.fileList = [];
            this.id = "";
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    height: 200px;
    width: 90%;
    .file {
        display: flex;
        align-items: center;
    }
}
::v-deep .el-upload-list {
    display: none;
}
</style>